import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    Button,
    useDisclosure,
    Text,
    RadioGroup,
    Stack,
    Radio,
    Box
} from '@chakra-ui/react'
import { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next';

const Disclaimer = ({ agreed }: { agreed: (value: boolean) => void }) => {

    const { isOpen, onOpen, onClose } = useDisclosure();
    const { t, i18n } = useTranslation();

    const [selectedLanguage, setSelectedLanguage] = useState<string | undefined>('en');

    useEffect(() => {
        onOpen();
    }, []);  // eslint-disable-line react-hooks/exhaustive-deps

    const disclaimerAgreementHandler = (value: boolean) => {
        agreed(value);
        onClose();
    }

    const handleLanguageChange = (lang: string) => {
        setSelectedLanguage(lang);
        void i18n.changeLanguage(lang);
    }

    return (
        <>
            <Modal isOpen={isOpen} onClose={() => disclaimerAgreementHandler(false)} closeOnEsc={false} closeOnOverlayClick={false}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>{t('disclaimer_title')}:</ModalHeader>
                    <ModalCloseButton />

                    <ModalBody color={'black'}>
                        <><Box mb={4} textAlign="center">
                            <Text fontWeight="bold" fontSize="lg">
                                Choose Language / Elegir idioma / Kies Idioma / 选择语言
                            </Text>
                        </Box><RadioGroup
                            onChange={(value) => handleLanguageChange(value)}
                            value={selectedLanguage}
                        >
                            <Stack direction="column" spacing={5} justify="center" mb={4}>
                                <div style={{ display: 'flex', justifyContent: 'space-around' }}>
                                    <Radio value="en">English</Radio>
                                    <Radio value="sp">Español</Radio>
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'space-around' }}>
                                    <Radio value="po">Papiamento</Radio>
                                    <Radio value="mn">普通话</Radio>
                                </div>
                            </Stack>
                        </RadioGroup></>

                        <Text mt={4} mb={2}>{t('disclaimer_first')}</Text>
                        <Text mb={2}>{t('disclaimer_second')}</Text>
                        <Text>{t('disclaimer_third')}</Text>
                    </ModalBody>

                    <ModalFooter>
                        <Button variant="cancel" mr={3} onClick={() => disclaimerAgreementHandler(false)}>
                            {t('cancel_btn')}
                        </Button>
                        <Button variant="brand" onClick={() => disclaimerAgreementHandler(true)}>
                            {t('agree_btn')}
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </>
    )
}

export default Disclaimer;
